import { IAppConfig, IAppVersion } from '../types';

import { handleJsonResponse } from './fetchHelpers';

export function getAppsVersionsRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  appName = 'TREAT',
): Promise<IAppVersion[]> {
  return handleJsonResponse(
    fetch(
      `${treatCanaryApiUrl}/apps/${appName}/versions?gwRegion=${gwRegion}`,
      {
        method: 'GET',
      },
    ),
  );
}

export function getGAversionRequest(
  { treatCanaryApiUrl, gwRegion }: IAppConfig,
  appName = 'TREAT',
): Promise<IAppVersion> {
  return handleJsonResponse(
    fetch(
      `${treatCanaryApiUrl}/apps/${appName}/versions/GA?gwRegion=${gwRegion}`,
      {
        method: 'GET',
      },
    ),
  );
}
